import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ParticipantRole } from '@getaccept/lib-shared/src/dealroom/types/enums/participant-role';
import type { Participant, ParticipantPublishedDTO } from '../types';

export default class ParticipantHelper {
  static getFullName = (participant: Partial<Participant>) =>
    `${participant?.firstName || ''} ${participant?.lastName || ''}`.trim();

  static formatParticipant = (participant: ParticipantPublishedDTO): Participant => {
    const clonedParticipant = { ...participant };
    const details = { ...clonedParticipant.details };
    delete clonedParticipant.details;
    return {
      ...clonedParticipant,
      ...details,
      fullName: ParticipantHelper.getFullName(details),
    };
  };

  static formatTitleAndCompanyName(participant: Partial<Participant>, showComma = true) {
    if (!participant.companyName && !participant.title) {
      return '';
    }

    const comma = showComma ? ',' : '';

    if (participant.companyName && participant.title) {
      return `${comma} ${participant.title} ${t('dsr_at_company')} ${participant.companyName}`;
    }

    if (participant.title) {
      return `${comma} ${participant.title}`;
    }

    return `${comma} ${participant.companyName}`;
  }

  static sendersWithWidgetActive = (participants: Participant[]) =>
    participants
      .filter(participant => participant.widget?.show || participant.role === ParticipantRole.Owner)
      .sort((a, b) => {
        if (a.role === ParticipantRole.Owner) return -1;
        if (b.role === ParticipantRole.Owner) return 1;

        const nameA = ParticipantHelper.getFullName(a);
        const nameB = ParticipantHelper.getFullName(b);

        return nameA.localeCompare(nameB);
      });
}
